import { _getByPath } from './helpers';
export function get(source, key) {
    if (!key) {
        return source;
    }
    return _getByPath(source, key.split('/'));
}
